import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, map, switchMap } from 'rxjs/operators';
import { UserDao } from '../../../core/services/dao/userDao';

interface NameCheckReturn {
  emailDuplicate: boolean;
}

@Directive({
  selector: '[enrollEmailDuplicate]',
  providers: [
    { provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => EnrollEmailDuplicateDirective), multi: true }
  ]
})
export class EnrollEmailDuplicateDirective implements AsyncValidator {
  @Input() enrollEmailDuplicate: Observable<string>;

  constructor(private userDao: UserDao) {}

  validate(control: AbstractControl): Observable<ValidationErrors> {
    return this.enrollEmailDuplicate.pipe(
      // debounceTime(100), //wait for 100 ms of no user input //commented out, the debounce time is preventing checks
      //  to occur in a timely manner.
      distinctUntilChanged(), //only if value has changed
      switchMap((emailString: string) => this.userDao.checkEmail<NameCheckReturn>(emailString)), //send our request but only care about the last one in flight
      map((data: any) => {
        return data.emailDuplicate ? data : null;
      }), //transform result
      first() //You need this for displaying template driven form errors
    );
  }
}
